__turbopack_context__.v({
  "careDescriptionBottom": "Warranty-module-scss-module__6WJ0XW__careDescriptionBottom",
  "careDescriptionTop": "Warranty-module-scss-module__6WJ0XW__careDescriptionTop",
  "careHeading": "Warranty-module-scss-module__6WJ0XW__careHeading",
  "careImage": "Warranty-module-scss-module__6WJ0XW__careImage",
  "careImageWrapper": "Warranty-module-scss-module__6WJ0XW__careImageWrapper",
  "container": "Warranty-module-scss-module__6WJ0XW__container",
  "content": "Warranty-module-scss-module__6WJ0XW__content",
  "description": "Warranty-module-scss-module__6WJ0XW__description",
  "descriptionWrapper": "Warranty-module-scss-module__6WJ0XW__descriptionWrapper",
  "duration": "Warranty-module-scss-module__6WJ0XW__duration",
  "durationValue": "Warranty-module-scss-module__6WJ0XW__durationValue",
  "exploreLink": "Warranty-module-scss-module__6WJ0XW__exploreLink",
  "exploreLinkWrapper": "Warranty-module-scss-module__6WJ0XW__exploreLinkWrapper",
  "extensionBox": "Warranty-module-scss-module__6WJ0XW__extensionBox",
  "extensionDescription": "Warranty-module-scss-module__6WJ0XW__extensionDescription",
  "extensionDetails": "Warranty-module-scss-module__6WJ0XW__extensionDetails",
  "extensionInfo": "Warranty-module-scss-module__6WJ0XW__extensionInfo",
  "extensionLink": "Warranty-module-scss-module__6WJ0XW__extensionLink",
  "extensionYears": "Warranty-module-scss-module__6WJ0XW__extensionYears",
  "flexSpace": "Warranty-module-scss-module__6WJ0XW__flexSpace",
  "gridWrapper": "Warranty-module-scss-module__6WJ0XW__gridWrapper",
  "heading": "Warranty-module-scss-module__6WJ0XW__heading",
  "leftColumn": "Warranty-module-scss-module__6WJ0XW__leftColumn",
  "rightColumn": "Warranty-module-scss-module__6WJ0XW__rightColumn",
  "section": "Warranty-module-scss-module__6WJ0XW__section",
  "terms": "Warranty-module-scss-module__6WJ0XW__terms",
  "warrantyBadgeSvg": "Warranty-module-scss-module__6WJ0XW__warrantyBadgeSvg",
  "warrantyDuration": "Warranty-module-scss-module__6WJ0XW__warrantyDuration",
  "warrantyWrapper": "Warranty-module-scss-module__6WJ0XW__warrantyWrapper",
});
